import entityReducer from "./userEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
